import { Component, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-pms',
  templateUrl: './pms.component.html',
  styleUrls: ['./pms.component.css']
})
export class PmsComponent implements OnInit {

  projectId = environment.projectId;
  userId: string;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    const userInfo = this.authService.getLoggedUserDetails();
    this.userId = userInfo.strUserId;
  }

}
